import React from 'react';
import { Input, Button, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission } from 'utils';
import { UserService } from 'services';
import Viewer from 'react-viewer';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalDocuments extends React.Component<Props> {

	state = {
		visible: false,
		file: ''
	}

	setVisible = (value: boolean) => {
		this.setState({
			visible: value
		});
	}

	view = (e: any, url: string) => {
		e.preventDefault();
		this.setState({
			visible: true,
			file: url
		});
	}
	
	render() {
		const { visible } = this.state;

		return (
			<>
				<Viewer
			      visible={ visible }
			      onClose={ () => this.setVisible(false) }
			      images={ [{ src: this.state.file }] }
			    />

				<div id="modal-users-valid">
					{
						this.props.item?.person?.document_photo && (
							<a href="#" onClick={ (e: any) => this.view(e,Constants.BASE_STORAGE + this.props.item?.person?.document_photo) }>
								<div className="item-document">
									<img src={ Constants.BASE_STORAGE + this.props.item?.person?.document_photo } className="document_photo" />
									<p>Documento de Identidad</p>
								</div>
							</a>
						)
					}
					{
						this.props.item?.person?.selfie && (
							<a href="#" onClick={ (e: any) => this.view(e,Constants.BASE_STORAGE + this.props.item?.person?.selfie) }>
								<div className="item-document">
									<img src={ Constants.BASE_STORAGE + this.props.item?.person?.selfie } className="document_photo" />
									<p>Selfie</p>
								</div>
							</a>
						)
					}
					{
						this.props.item?.person?.tax_document && (
							<a href="#" onClick={ (e: any) => this.view(e,Constants.BASE_STORAGE + this.props.item?.person?.tax_document) }>
								<div className="item-document">
									<img src={ Constants.BASE_STORAGE + this.props.item?.person?.tax_document } className="document_photo" />
									<p>RIF/Documento Fiscal</p>
								</div>
							</a>
						)
					}
				</div>
			</>
		)
	}
}

export default ModalDocuments;